import { Injectable, EventEmitter, Output, Directive } from '@angular/core';
import { User } from '../Model/user.Model';
import { GenericService } from '../Services/generic.service';
import { UserVistaPermissions } from '../Model/UserPermission.Model';
import { Router } from '@angular/router';
import { UserVistaAuthentificate } from '../Model/UserVistaAuthentificate';
import { MarketCompany } from '../Model/MarketCompany.Model';
import { Global } from '../modules/shared/global';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { AccessRightService } from './access-right.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  public token: string;
  Users: User[];
  CurrentUser: User;
  //usersPermissions: UserVistaPermissions[];
  marketcompanies: MarketCompany[];
  userVistaAuthentificate: UserVistaAuthentificate[];
  userVistaAuth: UserVistaAuthentificate;
  CurrentuserPermissions: UserVistaPermissions;
  UserEmail: string = localStorage.getItem('Vista_userEmail');
  UserName: string = '';
  UserId: string;
  showMco: number = 0;
  CoherencyTest: number = 0;
  BaseUrl: string = localStorage.getItem('Vista_urlapi');
  busyHome: Subscription;
  _userPermission: any = localStorage.getItem('Vista_userPermissionId');
  public get UserPermission(): any {
    return this._userPermission;
  }
  public set UserPermission(userPermission: any) {
    this._userPermission = userPermission;
  }
  @Output()
  event: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  eventShowMco: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  eventMcos: EventEmitter<MarketCompany[]> = new EventEmitter<
    MarketCompany[]
  >();

  IsManageUsers: boolean = false;
  public isLoading: boolean = true;

  public isLoadingBehaviour$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    private genericService: GenericService,
    private router: Router,
    private AccessRightService: AccessRightService
  ) {}

  AuthToken(): void {
    this.UserEmail = localStorage.getItem('Vista_userEmail');
    this.BaseUrl = localStorage.getItem('Vista_urlapi');
    if (!this.BaseUrl.endsWith('/')) this.BaseUrl = this.BaseUrl.concat('/');
    //this.GetUsers();
    this.AuthentificateVista();
  }

  ReturnValidToken(): string {
    return localStorage.getItem('access_token');
  }

  Remove(): void {
    // clear token remove user from local storage to log user out
    this.token = null;
    localStorage.removeItem('access_token');
    localStorage.removeItem('expires_in');
    localStorage.removeItem('generes_in');
  }

  /** Authentificate in Vista */
  AuthentificateVista(): void {
    let userEmail: string = '';
    if (localStorage.getItem('Vista_EnvironementProd') == '1')
      userEmail = this.UserEmail;
    this.userVistaAuth = new UserVistaAuthentificate();
    this.userVistaAuthentificate = [];
    this.genericService
      .get(this.BaseUrl.concat('api/WebAppAccessApi/Authentificate'))
      .subscribe((data: any) => {
        if (data.OK) {
          // utilisateur trouvé dans vista
          this.userVistaAuthentificate = data.items;
          this.userVistaAuth = this.userVistaAuthentificate[0];
          this.UserName =
            this.userVistaAuth.UserFistName +
            ' ' +
            this.userVistaAuth.UserLastName;
          this.UserId = this.userVistaAuth.UserId.toString();
          this.showMco =
            this.userVistaAuth.UserPRGroup || this.userVistaAuth.MultipleMco > 1
              ? 1
              : 0;
          localStorage.setItem('Vista_showFilterMco', this.showMco.toString());
          this.CoherencyTest = this.userVistaAuth.CoherencyTest == true ? 1 : 0;
          localStorage.setItem(
            'Vista_showCoherencyTest',
            this.CoherencyTest.toString()
          );
          this.eventShowMco.emit(localStorage.getItem('Vista_showFilterMco'));
          localStorage.setItem(
            'Vista_userName',
            this.userVistaAuth.UserFistName +
              ' ' +
              this.userVistaAuth.UserLastName
          );
          localStorage.setItem(
            'Vista_userId',
            this.userVistaAuth.UserId.toString()
          );
          this.event.emit(localStorage.getItem('Vista_userName'));
          localStorage.setItem(
            'Vista_userPermissionId',
            this.userVistaAuth.UserVistaPermissionsId.toString()
          );
          let userParamProcEdit =
            this.userVistaAuth.UserPRGroup && this.userVistaAuth.UserManageUsers
              ? 1
              : 0;
          localStorage.setItem(
            'Vista_userParamProcEdit',
            userParamProcEdit.toString()
          );
          this.getMarketCompany();
          this.busyHome = this.getUserPermission().subscribe(
            (response: any) => {
              this.UserPermission = response;
              this.setPermissionStorage(response);
              this.getUserdetails();
              this.isLoading = false;
              this.isLoadingBehaviour$.next(false);
              this.AccessRightService.isLoading = false;
              this.router.navigate(['/home']);
            }
          );
        } else {
          // utilisateur non trouvé dans vista
          localStorage.removeItem('Vista_userName');
          localStorage.removeItem('Vista_userId');
          this.router.navigate(['/LoginVista']);
        }
      });
  }

  setPermissionStorage(data) {
    window.localStorage.setItem('DatOne', data.MarketCoMasterData);
    window.localStorage.setItem('DatTwo', data.FinacialInformationData);
    window.localStorage.setItem('Datthree', data.EposInformationData);
    window.localStorage.setItem('DatFor', data.PromotionPlansData);
    window.localStorage.setItem('DatFive', data.AdvancedData);
    window.localStorage.setItem('ParOne', data.FinacialParameters);
    window.localStorage.setItem('ParTwo', data.PromotionParameters);
    window.localStorage.setItem('ParThree', data.DailyRosFirstDayParameters);
    window.localStorage.setItem('ParFor', data.SeasonalitesParameters);
    window.localStorage.setItem('ParFive', data.EposManagementParameters);
    window.localStorage.setItem('ParSix', data.AdvancedParameters);
    window.localStorage.setItem('ParSeven', data.AdditionalParameters);
    window.localStorage.setItem('ParEight', data.PricingParameters);
    window.localStorage.setItem('ParNine', data.CompetitionParameters);
  }
  getUserdetails() {
    var userId = localStorage.getItem('Vista_userId');
    if (userId != null)
      this.genericService
        .get(Global.BASE_API_Users + 'GetConnectedUser')
        .subscribe((data: any) => {
          this.CurrentUser = data;
          if (this.CurrentUser != null)
            this.IsManageUsers =
              this.CurrentUser.UserManageUsers == null
                ? false
                : this.CurrentUser.UserManageUsers;
        });
  }
  getMarketCompany(): void {
    if (
      this.genericService.ListMarketCompany == null ||
      this.genericService.ListMarketCompany.length < 1
    ) {
      this.genericService
        .get(
          this.BaseUrl.concat('api/MarketCompanyApi/GetAll?id=' + this.UserId)
        )
        .subscribe((data: any) => {
          this.marketcompanies = data;
          this.eventMcos.emit(this.marketcompanies);
          this.genericService.ListMarketCompany = data;
        });
    } else {
      this.marketcompanies = this.genericService.ListMarketCompany;
    }
  }
  getUserPermission(): Observable<any> {
    var PermissionId = localStorage.getItem('Vista_userPermissionId');
    if (PermissionId != null)
      return this.genericService.get(
        Global.BASE_API_WebAppAccess + 'GetPermissionByConnectedUser'
      );
  }
  /** Old Method */
  //GetUsers() {
  //  this.Users = [];
  //  this.genericService.get(this.BaseUrl.concat('api/UserManagementApi/Get'))
  //    .subscribe(
  //      (users: any) => {
  //        this.Users = users;
  //        if (this.Users.length > 0)
  //          this.GetCurrentUser();
  //      }
  //    )
  //}

  //GetCurrentUser() {
  //  this.CurrentUser = new User();
  //  let userEmail: string = "";
  //  if (localStorage.getItem('Vista_EnvironementProd') == "1")
  //    userEmail = this.UserEmail;

  //  this.CurrentUser = this.Users.filter(x => x.UserEmail.toUpperCase() == userEmail.toUpperCase())[0];
  //  if (this.CurrentUser != null) {
  //    this.UserName = this.CurrentUser.UserFistName + ' ' + this.CurrentUser.UserLastName;
  //    this.UserId = this.CurrentUser.UserId.toString();
  //    localStorage.setItem('Vista_userName', this.CurrentUser.UserFistName + ' ' + this.CurrentUser.UserLastName);
  //    localStorage.setItem('Vista_userId', this.CurrentUser.UserId.toString());
  //    this.event.emit(localStorage.getItem('Vista_userName'));
  //    this.getUsersPermission();
  //  }
  //  else {
  //    localStorage.removeItem('Vista_userName');
  //    localStorage.removeItem('Vista_userId');
  //    this.router.navigate(['/LoginVista']);
  //  }
  //}

  //getUsersPermission() {
  //  this.usersPermissions = [];
  //  this.CurrentuserPermissions = new UserVistaPermissions();
  //  this.genericService.get(this.BaseUrl.concat('api/WebAppAccessApi/Get/'))
  //    .subscribe(
  //      (data: any) => {
  //        this.usersPermissions = data;
  //        if (this.usersPermissions.length > 0) {
  //          this.GetCurrentUserPermissions();
  //        }
  //      }
  //    )
  //}

  //GetCurrentUserPermissions(): void {
  //  this.CurrentuserPermissions = this.usersPermissions.filter(x => x.UserId == +this.UserId)[0];
  //  if (this.CurrentuserPermissions != null) {
  //    localStorage.setItem('Vista_userPermissionId', this.CurrentuserPermissions.UserVistaPermissionsId.toString());
  //    this.router.navigate(['/home']);
  //  }
  //}
}
